function Button({children, className, ...rest}) {
  return (
    <button className={className + " bg-orange text-white font-inter font-bold tracking-wider text-md pb-5 pt-4 px-8 rounded-full hover:bg-orange/90"} {...rest}>
      {children}
    </button>
  )
}

export default Button;
